export const APIStatusData = {
    loading: false,
    error: null,
    queryData: null,
  }
  export const SubmitAPIStatusData = {
    loading: false,
  }